/* global SelectAttendeesVariant */
"use strict";

($dt => {

	// Localized Constants
	const { TOPIC_TYPES, DEBOUNCE_DEFAULT } = $dt.TopicGrid.Constants; 

	// Localized Functions
	//const { } = $dt.TopicGrid.Functions;

	class ThisVariant extends SelectAttendeesVariant {
		/**
		 * @param {string} key 
		 * @param {HTMLElement} select_attendees_elem
		 * @param {Block} block
		 * @param {InnerScreen} screen
		 */
		constructor(key, select_attendees_elem, block, screen, addOn) {
			super(key, select_attendees_elem, block, screen, addOn);
			this.children_elem = this.select_attendees_elem.querySelector('input[name="num_attendees_children"]');
		}

		setup() {
			this.setup_text_input_children();
			this.setup_increments_children();
			if (this.addOn) {
				this.addOn.setup();
			}
		}

		setup_text_input_children() {
			// Localize
			const { children_elem, block } = this;

			// Update Functions
			const update_children_value = () => {
				const { scheduling_info, current_topic } = block;
				const { children } = current_topic;

				if (children_elem.value.length > 0) {
					try {
						let value = parseInt(children_elem.value);
						if (!value || value < children.minimum_amount_of_children) {
							value = children.minimum_amount_of_children;
						} else if (value > children.maximum_amount_of_children) {
							value = children.maximum_amount_of_children;
						}

						children_elem.value = value;
						if (scheduling_info.children_attendees !== value) {
							scheduling_info.children_attendees = value;
						}

						// Refresh Ajax (price updates)
						this.screen.RefreshAjax(true);

						// Allow Next
						this.screen.ScreenIsValid();
					} catch (err) {
						// couldn't parse text input
						children_elem.value = '';
						this.screen.ScreenIsInvalid();
					}
				} else {
					this.screen.ScreenIsInvalid();
				}
			};

			// Changing attendees by typing or adjusting using device incrementers
			children_elem.addEventListener('keyup', $dt.Util.debounce(update_children_value, DEBOUNCE_DEFAULT));
			children_elem.addEventListener('change', $dt.Util.debounce(update_children_value, DEBOUNCE_DEFAULT));
		}

		setup_increments_children() {
			// Localize
			const { children_elem, block } = this;

			// Get Button Elems
			const incrementor_elems = this.select_attendees_elem.querySelectorAll('.increment-children .number-increment');

			// +/- buttons
			incrementor_elems.forEach(button_elem => {
				const direction = button_elem.getAttribute('data-direction');

				// One event for clickers
				button_elem.addEventListener('click', () => {
					const { scheduling_info, current_topic } = block;
					const { children } = current_topic;

					if (children_elem.value.length === 0) {
						children_elem.value = children.minimum_amount_of_children;
					}
					try {
						let value = parseInt(children_elem.value);
						if (direction === 'down') {
							if (value > children.minimum_amount_of_children) {
								value--;
							} else {
								value = children.minimum_amount_of_children;
							}
						} else {
							if (value < children.maximum_amount_of_children) {
								value++;
							} else {
								value = children.maximum_amount_of_children;
							}
						}

						if (scheduling_info.children_attendees !== value) {
							scheduling_info.children_attendees = value;
							children_elem.value = value;
						}

						// Allow Next
						this.screen.ScreenIsValid();
					} catch (err) {
						// Couldn't parse value
						children_elem.value = '';
						this.screen.ScreenIsInvalid();
					}
				});

				// Another debounced event for refreshing the calendar
				button_elem.addEventListener('click', $dt.Util.debounce(() => {
					// Refresh Ajax (price udpates)
					this.screen.RefreshAjax(true);
				}, DEBOUNCE_DEFAULT));
			});
		}

		show() {
			const { children_elem, block } = this;
			const { scheduling_info } = block;
	
			// Set inputs
			children_elem.value = scheduling_info.children_attendees;

			// Addon
			if (this.addOn) {
				this.addOn.show();
			}
		}
	}
	
	/**
	 * 
	 * @param {HTMLElement} select_attendees_elem 
	 * @param {Block} block 
	 * @param {InnerScreen} screen
	 * @returns {ThisVariant}
	 */
	const createStgVariant = (select_attendees_elem, block, screen) => {
		const addOnVariant = $dt.TopicGrid.SelectAttendees.createAddOnVariant(select_attendees_elem, block, screen);
		return new ThisVariant(TOPIC_TYPES.SCIENCE_TO_GO, select_attendees_elem, block, screen, addOnVariant);
	};

	// Save to object
	$dt.TopicGrid.SelectAttendees.createStgVariant = createStgVariant;

})(window.d3_wp_themejs);
